
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[parent]",
      function () {
        return require("private-next-pages/[parent]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[parent]"])
      });
    }
  